const cookieMaxAge = 2592000; // 30 days

const queueCookie = (key, value) => {
  document.cookie = `${key}=${value}; path=/; max-age=${cookieMaxAge}; secure; samesite=lax`;
};

// Detect device type
const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

// Track device type
queueCookie("device_type", getDeviceType());

// Detect browser
const getBrowser = () => {
  const ua = navigator.userAgent;
  let browser = "unknown";

  if (ua.includes("Firefox")) {
    browser = "firefox";
  } else if (ua.includes("Chrome") && !ua.includes("Edg")) {
    browser = "chrome";
  } else if (ua.includes("Safari") && !ua.includes("Chrome")) {
    browser = "safari";
  } else if (ua.includes("Edg")) {
    browser = "edge";
  } else if (ua.includes("MSIE") || ua.includes("Trident/")) {
    browser = "ie";
  } else if (ua.includes("Opera") || ua.includes("OPR/")) {
    browser = "opera";
  }

  return browser;
};

// Track browser
queueCookie("browser", getBrowser());

// Track user agent
queueCookie("user_agent", encodeURIComponent(navigator.userAgent));

// Track referrer with fallback
const referrer = document.referrer || window.location.href;
queueCookie("referrer_url", encodeURIComponent(referrer));
